// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"df9129c0","219":"e6b4c411","368":"5ee09d24","591":"9547d861","726":"813d2890","849":"c322dbe3","906":"f8a940e2","922":"0a4eccce","973":"0a4eccce"}[chunkId] + ".chunk.css";
};